<script setup>
import SeedRecord from '~/components/Modals/SeedRecord.vue';
const emit=defineEmits(['modal:remove','record:saved']);
const plant=ref(null),choosing=ref(true),search=ref(),recordForm=ref();
async function select(item){plant.value=item;choosing.value=false;await nextTick();recordForm.value?.focus();}
async function back(){choosing.value=true;await nextTick();search.value?.focus();}
onMounted(()=>search.value?.focus());
</script>
<template>
 <div class="pc-personal-record-picker">
  <div v-show="choosing" class="pc-record-search-step">
   <h2>Добавить личный рекорд</h2>
   <p>Найдите растение или сорт. Введите минимум три буквы и выберите его из списка.</p>
   <CatalogSearch ref="search" :hide-create="true" @selected="select"/>
  </div>
  <div v-if="plant" v-show="!choosing" class="pc-record-details-step">
   <button type="button" class="uo-btn uo-btn-quiet" @click="back">← Выбрать другое растение</button>
   <SeedRecord ref="recordForm" :seed_id="plant.id" :seed_title="plant.title" @record:saved="emit('record:saved',$event)" @modal:remove="emit('modal:remove')"/>
  </div>
 </div>
</template>
<style scoped>
.pc-personal-record-picker{min-width:0;width:100%;max-width:560px}.pc-record-search-step{display:grid;gap:16px;min-height:240px}.pc-record-search-step h2{margin:0;padding-right:var(--uo-spacing-10)}.pc-record-search-step p{margin:0;color:var(--uo-color-text-secondary);font:400 14px/20px var(--uo-typography-fontFamily-ui)}.pc-record-details-step{display:grid;gap:12px;min-width:0}.pc-record-details-step>.uo-btn{justify-self:start;padding-right:var(--uo-spacing-10)}.pc-record-search-step :deep(.uo-search-suggestions){position:static;max-height:min(40dvh,320px);margin-top:var(--uo-spacing-3);box-shadow:none}
</style>
